import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { API } from "@/App";

const CURRENCIES = {
  TRY: { symbol: "₺", code: "TRY", name: "Türk Lirası", position: "before" },
  USD: { symbol: "$", code: "USD", name: "US Dollar", position: "before" },
  EUR: { symbol: "€", code: "EUR", name: "Euro", position: "before" },
  GBP: { symbol: "£", code: "GBP", name: "British Pound", position: "before" },
};

const CurrencyContext = createContext();

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) {
    return {
      currency: CURRENCIES.TRY,
      currencyCode: "TRY",
      formatPrice: (amount) => `₺${Number(amount || 0).toLocaleString()}`,
      currencySymbol: "₺",
      CURRENCIES,
      setCurrencyCode: () => {},
    };
  }
  return ctx;
};

export const CurrencyProvider = ({ children }) => {
  const [currencyCode, setCurrencyCode] = useState("TRY");

  const fetchCurrency = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token || !API) return;
      const res = await fetch(`${API}/business/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        if (data.currency) {
          setCurrencyCode(data.currency);
          try { localStorage.setItem("pbstudio_currency_code", data.currency); } catch (_) {}
        }
      }
    } catch (e) {
      // silently fail
    }
  }, []);

  useEffect(() => {
    fetchCurrency();
  }, [fetchCurrency]);

  const currency = CURRENCIES[currencyCode] || CURRENCIES.TRY;

  const formatPrice = useCallback(
    (amount) => {
      const num = Number(amount || 0);
      const formatted = num.toLocaleString();
      return `${currency.symbol}${formatted}`;
    },
    [currency]
  );

  return (
    <CurrencyContext.Provider
      value={{
        currency,
        currencyCode,
        setCurrencyCode,
        formatPrice,
        currencySymbol: currency.symbol,
        CURRENCIES,
        refreshCurrency: fetchCurrency,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};
